import React, { Suspense, lazy, useEffect, useState } from 'react';
import { DemoOne } from './components/demo';
import { SiteLogo } from './components/ui/site-logo';

const ShaderAnimation = lazy(() =>
  import('./components/ui/shader-animation').then((module) => ({
    default: module.ShaderAnimation,
  })),
);

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsFadingOut(true);
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div
        className={`fixed inset-0 z-50 transition-opacity duration-500 ${
          isFadingOut ? 'opacity-0' : 'opacity-100'
        }`}
      >
        <Suspense fallback={<div className="fixed inset-0 bg-black" aria-hidden="true" />}>
          <ShaderAnimation />
        </Suspense>
        <div className="absolute inset-0 flex flex-col items-center justify-center px-4">
          <div className="text-white text-center">
            <SiteLogo
              fetchPriority="high"
              className="w-48 h-48 sm:w-56 sm:h-56 md:w-64 md:h-64 lg:w-72 lg:h-72 xl:w-80 xl:h-80 mb-4 sm:mb-6 mx-auto"
            />
            <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-medium tracking-tight text-white/90 px-2">
              William Wilder Nash
            </h2>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="animate-fade-in h-dvh w-full overflow-hidden">
      <DemoOne />
    </div>
  );
}

export default App;
